import { Pagination } from "@mui/material";
import { BackpackIcon } from "@radix-ui/react-icons";
import { MoreHorizontal, Search } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
import {
  ACTIVER_DESACTIVER_PRESTATAIRE,
  DELETE_PLANING,
  LIST_PLANING,
  LISTE_COMMUNE_SANS_PAGINATION,
  LISTE_PRESTATAIRE,
} from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { UpdateTeam } from "../../components/utilisateur/UpdateTeam";
import { deleteOne, disable, find } from "../../services/service";
import { useGlobalStore } from "../../store/store";
import { useStoreApp } from "../../store/storeApp";
import { AddPrestataire } from "./AddPrestataire";

export const Prestataire = () => {
  const planing = useGlobalStore();
  const prestataire = useStoreApp();

  const [item, setItem] = useState(null);
  const [param, setParam] = useState({
    prestataireId: "",
    communeId: "",
    equipeId: "",
  });
  const [communes, setCommunes] = useState([]);
  const [loadingCommunes, setLoadingCommunes] = useState(false);
  const [communeId, setCommuneId] = useState("");

  const refresh = (page = 0, search = "", commune = communeId) =>
    prestataire.getData(
      LISTE_PRESTATAIRE,
      { page, param: search, size: 10 },
      `&communeId=${commune}`,
    );

  useEffect(() => {
    refresh(0, "", communeId);
  }, [communeId]);

  useEffect(() => {
    const loadCommunes = async () => {
      setLoadingCommunes(true);
      try {
        const res = await find(
          `${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=${param.prestataireId}`,
        );
        setCommunes(res?.data?.data ?? res?.data?.donnee ?? res?.data ?? []);
      } catch {
        setCommunes([]);
      } finally {
        setLoadingCommunes(false);
      }
    };
    loadCommunes();
  }, []);

  const more = (page) =>
    prestataire.getData(
      LISTE_PRESTATAIRE,
      { page: page - 1, param: "", size: 10 },
      "",
    );

  const closeBtnCls =
    "w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition";

  return (
    <div>
      {/* Delete planning modal */}
      <dialog id="delete" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Cette planification sera définitivement supprimée.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button
                id="close_delete"
                className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              >
                Annuler
              </button>
            </form>
            <form method="dialog">
              <button
                onClick={() => {
                  deleteOne(DELETE_PLANING, item?.publicId)
                    .then(() => {
                      planing.getData(
                        `${LIST_PLANING}?equipeId=${param.equipeId}&communeId=${param.communeId}&prestataireId=${param.prestataireId}`,
                      );
                      toast.success("Planification supprimée");
                    })
                    .catch(() => {});
                }}
                className="h-9 px-4 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition"
              >
                Supprimer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      {/* Add prestataire modal */}
      <dialog id="add_prestataire" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-xl">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Nouveau prestataire
            </h2>
            <form method="dialog">
              <button id="close_prestataire" className={closeBtnCls}>
                ✕
              </button>
            </form>
          </div>
          <AddPrestataire />
        </div>
      </dialog>

      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-4xl font-bold text-gray-900 tracking-tight">
          Prestataires
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Liste des prestataires enregistrés dans le système
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        {/* Search */}
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <Search size={15} color="#9ca3af" />
          <input
            onChange={(e) => refresh(0, e.target.value, communeId)}
            type="text"
            placeholder="Rechercher un prestataire…"
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-48"
          />
        </div>

        {/* Commune filter */}
        <select
          className="h-10 px-3 border border-gray-200 rounded-xl text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition"
          onChange={(e) => setCommuneId(e.target.value)}
          disabled={loadingCommunes}
        >
          <option value="">
            {loadingCommunes ? "Chargement…" : "Toutes les communes"}
          </option>
          {communes?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.designation}
            </option>
          ))}
        </select>

        <button
          onClick={() => document.getElementById("add_prestataire").showModal()}
          className="ml-auto h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-xl transition"
        >
          Ajouter un prestataire
        </button>
      </div>

      {/* Grid */}
      {prestataire?.loading ? (
        <Loader />
      ) : prestataire?.data?.data?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun prestataire trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
          {prestataire?.data?.data?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Modals per item */}
              <dialog id={`update_Team${item?.equipe?.id}`} className="modal">
                <div className="modal-box rounded-2xl p-6 max-w-xl">
                  <div className="flex items-center justify-between mb-5">
                    <h2 className="text-lg font-bold text-gray-900">
                      Modifier l'équipe
                    </h2>
                    <form method="dialog">
                      <button className={closeBtnCls}>✕</button>
                    </form>
                  </div>
                  <UpdateTeam item={item} />
                </div>
              </dialog>

              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-44 p-1.5"
                >
                  <li>
                    <NavLink
                      to={`details/${item?.id}/${item?.designation}`}
                      className="block h-8 px-3 leading-8 text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                    >
                      Détails
                    </NavLink>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => {
                        disable(ACTIVER_DESACTIVER_PRESTATAIRE, item?.id).then(
                          (res) => {
                            if (res.status === 200) {
                              refresh();
                              toast.success("Opération effectuée");
                            }
                          },
                        );
                      }}
                    >
                      {item?.isActif ? "Désactiver" : "Activer"}
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0 text-amber-600">
                <BackpackIcon />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 pr-6">
                <p className="text-xs font-semibold text-gray-900 truncate">
                  {item?.designation}
                </p>
                <span
                  className={`inline-block mt-1.5 text-xs font-medium px-2 py-0.5 rounded-full ${
                    item?.isActif
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  {item?.isActif ? "Actif" : "Inactif"}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      {prestataire?.data?.totalPages > 1 && (
        <div className="flex justify-end mt-6">
          <Pagination
            onChange={(_, v) => more(v)}
            count={prestataire?.data?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
            size="small"
          />
        </div>
      )}
    </div>
  );
};
